import React, { useEffect, useState } from "react";
import { serviceDetailsList } from "../service/ServiceMaster/ServiceMaster";

const Pricing = () => {
  const [pricingData, setPricingData] = useState([]);
  const URL = process.env.REACT_APP_API_URL;
  const baseURL = URL.replace("/v1", "");
  const imageURL = `${baseURL}/images/`;

  const getServicelist = () => {
    serviceDetailsList()
      .then((res) => {
        const dataArray = res?.data?.data || [];
        const pricingItem = dataArray.find(
          (item) => item.servicetype === "Pricing"
        );
        if (pricingItem) {
          setPricingData(pricingItem);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getServicelist();
  }, []);

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return "";

    // Extract video ID from standard, shortened, or share URLs
    const videoIdMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?\/]+)/
    );
    if (!videoIdMatch) return "";

    const videoId = videoIdMatch[1];

    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <div className="main">
      <div
        className="site-breadcrumb"
        style={{
          backgroundImage: pricingData?.mainImage
            ? `url(${imageURL}${pricingData?.mainImage})`
            : "", // Fallback image if mainImage is not available
        }}
      >
        <div className="container">
          <h2 className="breadcrumb-title">Pricing</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="/">Home</a>
            </li>
            <li className="active">Pricing</li>
          </ul>
        </div>
      </div>

      <div className="schedule-single py-120">
        <div className="container">
          <div className="schedule-single-wrap">
            <div className="row g-4">
              <div className="col-xl-12 col-lg-12">
                <div className="schedule-detail">
                  {pricingData?.secondImage && (
                    <div className="schedule-detail-img mb-30">
                      <img
                        src={`${imageURL}${pricingData?.secondImage}`}
                        alt="thumb"
                      />
                    </div>
                  )}

                  <div className="schedule-detail-info">
                    <h3 className="mb-20">{pricingData?.title}</h3>
                    <p
                      className="mb-20 contents"
                      dangerouslySetInnerHTML={{
                        __html:
                          pricingData.description &&
                          Array.isArray(pricingData.description) &&
                          pricingData.description[0]
                            ? JSON.parse(pricingData.description[0])
                            : "",
                      }}
                    ></p>

                    {pricingData?.link && (
                      <div className="video-area">
                        <div className="video-content">
                          <div className="video-wrapper">
                            <iframe
                              width="100%"
                              height="100%"
                              src={getYouTubeEmbedUrl(pricingData?.link)}
                              title="YouTube video player"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    )}
                    <p
                      className="mb-20 mt-20 contents"
                      dangerouslySetInnerHTML={{
                        __html:
                          pricingData.videodescription &&
                          pricingData.videodescription
                            ? JSON.parse(pricingData.videodescription)
                            : "",
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
